import * as React from "react";
import { FormContext } from "../../Form/Form/Form.js";
import { isValidComposedState } from "../../Util/Util/from-state.js";
const ComposedFormContext = React.createContext({});
const ComposedForm = (props) => {
  const [formState, setFormState] = React.useState(props.initialFormState);
  const state = React.useMemo(
    () => ({
      formName: props.name,
      formState: formState || {},
      formValid: !!formState && isValidComposedState(formState)
    }),
    [props.name, formState]
  );
  React.useEffect(() => props.onChange && props.onChange(state), [state]);
  React.useLayoutEffect(() => setFormState(props.initialFormState), [props.initialFormState]);
  const composedContext = {
    formName: props.name,
    onChange: React.useCallback((name, controlState) => {
      setFormState((current) => ({
        ...current,
        [name]: {
          ...current && current[name],
          [controlState.name]: controlState
        }
      }));
    }, []),
    getInitialState: React.useCallback(
      (name) => formState && formState[name],
      [formState]
    )
  };
  const handleFormSubmit = React.useCallback(
    (ev) => {
      ev && ev.preventDefault();
      props.onSubmit && props.onSubmit(state);
    },
    [props.name, props.onSubmit, state]
  );
  return /* @__PURE__ */ React.createElement(ComposedFormContext.Provider, { value: composedContext }, /* @__PURE__ */ React.createElement(
    "form",
    {
      noValidate: true,
      id: props.name,
      className: props.className,
      "data-t": props["data-t"] || props.name,
      onSubmit: handleFormSubmit,
      children: props.children
    }
  ));
};
const Part = ({
  name,
  children
}) => {
  const { formName, onChange, getInitialState } = React.useContext(ComposedFormContext);
  !onChange && console.error("ComposedForm.Part cannot be used outside of a ComposedForm");
  const formContext = {
    name: formName,
    onChange: React.useCallback((state) => onChange && onChange(name, state), [name, onChange]),
    getInitialState: React.useCallback(
      (fieldName) => (getInitialState && getInitialState(name) || {})[fieldName],
      [getInitialState]
    )
  };
  return /* @__PURE__ */ React.createElement(FormContext.Provider, { value: formContext, children });
};
ComposedForm.Part = Part;
export {
  ComposedFormContext,
  ComposedForm as default
};
//# sourceMappingURL=ComposedForm.js.map
